export const environment = {
    production:false,
    apiUrl:"https://api.rules-content.natrixsoftware.in/api",
    options : 
    {
        headers:{}
    }
};